"use client"

const ConfirmationModal = ({
  showConfirmation,
  orderDetails,           // ← New: pass all details in one object
  onConfirm,              // ← Standard name
  onCancel,               // ← Standard name
  remainingOrders,
}) => {
  if (!showConfirmation) return null

  const isLimitReached = remainingOrders <= 0;


  return (
    <div className="product-modal-overlay">
      <div className="confirmation-modal">
        <h4 className="fw-bold">Please review your details before submitting</h4>
        {isLimitReached ? (
          <div style={{
            padding: '12px',
            marginBottom: '16px',
            background: '#ffebee',
            border: '1px solid #ef9a9a',
            borderRadius: '6px',
            color: '#c62828',
            textAlign: 'center'
          }}>
            <strong>Daily limit reached (10 orders/day)</strong><br />
            You cannot place more orders today. Come back tomorrow.
          </div>
        ) : (
          <div style={{
            padding: '10px',
            marginBottom: '12px',
            background: '#e3f2fd',
            borderRadius: '6px',
            textAlign: 'center'
          }}>
            Remaining orders today: <strong>{remainingOrders}/10</strong>
          </div>
        )}
        <p><strong>Brand:</strong> {orderDetails.brand}</p>
        <p><strong>Grade:</strong> {orderDetails.grade}</p>
        <p>
          <strong>Site Address:</strong> {orderDetails.siteAddress?.address}, {orderDetails.siteAddress?.state}
          {orderDetails.siteAddress?.pincode && `, ${orderDetails.siteAddress?.pincode}`}
        </p>

        {orderDetails.quantity && (
          <p><strong>Quantity:</strong> {orderDetails.quantity} bags</p>
        )}

        {orderDetails.mt && (
          <p><strong>MT:</strong> {orderDetails.mt}</p>
        )}

        {orderDetails.currentRate && (
          <p><strong>Rate:</strong> ₹{orderDetails.currentRate} per bag</p>
        )}

        <p>
          <strong>Payment Amount:</strong>{" "}
          {orderDetails.paymentAmount === "0.00" && orderDetails.selectedSiteBalance > 0
            ? "₹0.00 (Using existing balance)"
            : `₹${Number(orderDetails.paymentAmount).toLocaleString("en-IN")}`}
        </p>

        {orderDetails.paymentMethod === "utr" && orderDetails.utrNumber && (
          <p><strong>UTR Number:</strong> {orderDetails.utrNumber}</p>
        )}

        {orderDetails.selectedSiteBalance > 0 && (
          <div className="balance-info">
            <p><strong>Available Balance:</strong> ₹{orderDetails.selectedSiteBalance.toLocaleString("en-IN")}</p>
          </div>
        )}

        <div className="product-modal-buttons">
          <button 
            onClick={onConfirm} 
            className="confirm-btn"
            disabled={isLimitReached}
          >
            Yes, Place Order
          </button>
          <button onClick={onCancel} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal